import React from 'react';
import Icon from '../common/Icons';
import AdminRowActionMenu from '../admin/ui/AdminRowActionMenu';
import '../admin/ui/AdminRowActionMenu.css';
import {
  formatMemberCompanyLine,
  formatMemberFullName,
  formatMemberMetaLine,
  getMemberTypeLabel,
  isMemberActive
} from './memberListUtils';

function getMemberInitials(member) {
  const nom = (member?.nom || '').trim();
  const prenom = (member?.prenom || '').trim();
  if (nom && prenom) return `${nom[0]}${prenom[0]}`.toUpperCase();
  if (nom) return nom.slice(0, 2).toUpperCase();
  if (prenom) return prenom.slice(0, 2).toUpperCase();
  if (member?.matricule) return String(member.matricule).slice(0, 2).toUpperCase();
  return 'A';
}

export default function MemberRowActionMenu({
  anchorEl,
  member,
  onClose,
  onView,
  onToggleStatus,
  onArchive,
  onRestore,
  onDelete,
  getCompanyName,
  formatDate,
  isArchiveView = false,
  menuCanToggle = true,
  theme = 'blue'
}) {
  if (!member || !anchorEl) return null;

  const fullName = formatMemberFullName(member);
  const metaLine = formatMemberMetaLine(member, {
    isChild: member.type !== 'AGENT',
    formatDate
  });
  const company = formatMemberCompanyLine(member, getCompanyName);
  const active = isMemberActive(member);

  const items = [
    {
      id: 'view',
      label: 'Voir la fiche',
      hint: 'Détails de l\'adhérent',
      icon: 'eye',
      tone: 'primary',
      onClick: () => {
        onClose();
        onView(member);
      }
    }
  ];

  if (!isArchiveView && menuCanToggle) {
    items.push({
      id: 'toggle',
      label: active ? 'Désactiver' : 'Activer',
      hint: active ? 'Suspendre la couverture' : 'Rétablir la couverture',
      icon: active ? 'eyeSlash' : 'checkCircle',
      tone: 'warn',
      onClick: () => {
        onToggleStatus(member);
        onClose();
      }
    });
  }

  if (isArchiveView && onRestore) {
    items.push({
      id: 'restore',
      label: 'Réintégrer',
      hint: 'Remettre dans le répertoire actif',
      icon: 'userPlus',
      tone: 'primary',
      onClick: () => {
        onRestore(member);
        onClose();
      }
    });
  }

  const footer = isArchiveView ? (
    <button
      type="button"
      role="menuitem"
      className="adm-row-menu__item adm-row-menu__item--danger"
      onClick={() => {
        onDelete(member.id);
        onClose();
      }}
    >
      <span className="adm-row-menu__icon adm-row-menu__icon--danger" aria-hidden>
        <Icon name="trash" size={15} />
      </span>
      <span className="adm-row-menu__item-text">
        <span className="adm-row-menu__item-label">Supprimer définitivement</span>
        <span className="adm-row-menu__item-hint">Action irréversible</span>
      </span>
    </button>
  ) : (
    <button
      type="button"
      role="menuitem"
      className="adm-row-menu__item adm-row-menu__item--danger"
      onClick={() => {
        onArchive(member);
        onClose();
      }}
    >
      <span className="adm-row-menu__icon adm-row-menu__icon--danger" aria-hidden>
        <Icon name="inbox" size={15} />
      </span>
      <span className="adm-row-menu__item-text">
        <span className="adm-row-menu__item-label">Archiver (débaucher)</span>
        <span className="adm-row-menu__item-hint">Retire l&apos;adhérent du répertoire actif</span>
      </span>
    </button>
  );

  return (
    <AdminRowActionMenu
      anchorEl={anchorEl}
      onClose={onClose}
      theme={theme}
      title={fullName}
      subtitle={metaLine || company.text}
      initials={getMemberInitials(member)}
      badges={[
        {
          label: active ? 'Actif' : 'Inactif',
          variant: active ? 'active' : 'inactive'
        },
        {
          label: getMemberTypeLabel(member.type),
          variant: 'neutral'
        }
      ]}
      items={items}
      extra={
        <span
          className={`ap-mem-company-line ${company.empty ? 'ap-mem-company-line--muted' : ''}`}
          title={company.title}
        >
          {company.text}
        </span>
      }
      footer={footer}
    />
  );
}
